module.exports = __webpack_public_path__ + "static/fonts/Fact-SemiExpandedBold.679838e.ttf";